import { useState, useEffect, useContext } from "react";
import { AppBar, Typography, Box, Breadcrumbs, Link } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { ViewReturnGoodGrnData } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { externalgetApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import { GRN_API_12, SETTING_API_15, GRN_API_17 } from "../../api/ApiModel";
import {
  CON_BUSINESS_TYPECODE,
  CON_STATUS_ACTIVE,
  CON_TRSTS_RETURN,
  CON_YES,
  CON_STATUS_RETURNAPPROVED,
  CON_PARAID,
  CON_STATUS_RETURNREJECTED,
} from "../../utils/sys/Constants";
import { FormatDate } from "../../utils/common/DateUtils";
import PrintIcon from '@mui/icons-material/Print';
import MailIcon from '@mui/icons-material/Mail';
import { SEARCH_FIELDS_RTNHISTORY } from "../../utils/sys/GrnSearchFeilds";
import SummarizeIcon from '@mui/icons-material/Summarize';
import FilterReturnSecrchByID from "../../components/grn/FilterReturnSecrchByID";
import DescriptionIcon from '@mui/icons-material/Description';
import { rowHeightWarning } from "@mui/x-data-grid/hooks/features/rows/gridRowsUtils";
import { DisabledByDefault } from "@mui/icons-material";
function GoodsReturnHistory() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const moduleParamJson = useSelector((state) => state.moduleParamJson);

  const { STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};
  const PARAID = moduleParamJson && moduleParamJson[0]?.PARAID;
  const PARAVALUE = moduleParamJson && moduleParamJson[0]?.PARAVALUE;

  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});

  const [grnStatusTypes, serGrnStatusTypes] = useState([]);

  const [allData, setAllData] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    warehouseOptions: [],
    statusOptions: [],
  });
  const [filters, setFilters] = useState({
    grnId: "",
    warehouse: "",
    status: "",
    fromDate: null,
    toDate: null,
    grnreturncode: "",
  });
  
  useEffect(() => {
    setPageData({
      title: "Purchases Return History",
    });
  }, []);

  const handleItemClick = (grncode, trsts, actionText, grnreturncode, returneddate,debitnoteno) => {
    localStorage.removeItem("returnedProducts");
    if (actionText === "View") {
      navigate("/vgrnrtnpage", {
        state: { grncode, trsts, grnreturncode,returneddate,debitnoteno },
      });
    } else if (actionText === "Edit") {
      navigate("/EditGrn", { state: { grncode, trsts } });
    } else if (actionText === "Edit") {
      navigate("/EditGrn", { state: { grncode, trsts } });
    } else if (actionText === "Print") {
      navigate("/vgrnnotes", { state: { grncode, trsts, grnreturncode ,page: "DebitNote",debitnoteno,doctype: "debitnote"}, });
    } else if (actionText === "Return Note") {
      navigate("/vgrnnotes", { state: { grncode, trsts, grnreturncode ,page: "ReturnNote",debitnoteno ,doctype: "returnnote",} });
    }
  };

const fmtCurrency = (val) => {
  if (val == null || val === "" || val === "-") return "-";

  const num = Number(val);

  if (Number.isNaN(num)) return "-";

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

  useEffect(() => {
    fetchGrnStatusTypes();
  }, []);

  useEffect(() => {
    if (grnStatusTypes.length) {
      fetchSupplierListData();
    }
  }, [grnStatusTypes]);

  const FetchWarehouses = async () => {
    try {
      const params = {
        COMPCODE,
        BUSINESSTYPECODE: CON_BUSINESS_TYPECODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(SETTING_API_15, "GET", params);

      setFilterOptions((prev) => ({
        ...prev,
        warehouseOptions: response || [],
      }));
    } catch (error) {
      console.error("Error fetching GRN document types", error);
    }
  };

  const fetchGrnStatusTypes = async () => {
    try {
      const result = await externalgetApi(GRN_API_12, "GET", {
        STS: CON_STATUS_ACTIVE,
      });

      console.log("fetchGrnStatusTypes", result);

      if (Array.isArray(result)) {
        const shouldIncludeAll =
          moduleParamJsonArray.filter((item) => item.PARAID === CON_PARAID)[0]
            ?.PARAVALUE === CON_YES;

        const filtered = result
          .filter((item) => {
            if (String(item.trcatcode) !== CON_TRSTS_RETURN) return false;

            if (shouldIncludeAll) {
              return (
                String(item.trsts) === CON_STATUS_RETURNAPPROVED ||
                String(item.trsts) === CON_STATUS_RETURNREJECTED
              );
            } else {
              return String(item.trsts) === CON_STATUS_RETURNAPPROVED;
            }
          })
          .map((item) => ({
            ...item, // keep original fields
            grnstatus: item.trenuserremark,
            grnstatuscode: item.trsts,
            //Remove default hardcoded color and use from constants
            colorcode: item.colorcode || "#000000", // default color if none
          }));

        serGrnStatusTypes(filtered);
        console.log("Filtered Status Types", filtered);

        // Now dynamically generate statusOptions from the filtered list
        const statusOpts = filtered.map((item) => ({
          code: item.trsts,
          label: item.trenuserremark,
          color: item.colorcode,
        }));
        setFilterOptions((prev) => ({
          ...prev,
          statusOptions: statusOpts,
        }));

        FetchWarehouses();
      }
    } catch (err) {
      console.error("Error fetching GRN status types:", err);
    }
  };

  const fetchSupplierListData = async () => {
    try {
      const result = await externalgetApi(GRN_API_17, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        TRCATCODE: CON_TRSTS_RETURN,
      });

      if (Array.isArray(result)) {
        const shouldIncludeAll =
          moduleParamJsonArray.filter((item) => item.PARAID === CON_PARAID)[0]
            ?.PARAVALUE === CON_YES;

        const filteredResult = result.filter((item) => {
          if (shouldIncludeAll) {
            return (
              String(item.trsts) === CON_STATUS_RETURNAPPROVED ||
              String(item.trsts) === CON_STATUS_RETURNREJECTED
            );
          } else {
            return String(item.trsts) === CON_STATUS_RETURNAPPROVED;
          }
        });

        const rowsWithId = filteredResult.map((item, index) => {
          const matchedStatus = grnStatusTypes.find(
            (status) => String(status.trsts) === String(item.trsts)
          );

          return {
            ...item,
            id: item.grnreturncode || index,
            invoicedate: FormatDate(item.invoicedate) || null,
            returneddate: FormatDate(item.returneddate) || null,
            endate: FormatDate(item.endate) || null,
            statusLabel: matchedStatus?.trenuserremark || "Unknown",
            statusColor: matchedStatus?.colorcode || "#0000",
            invoicedateRaw: item.returneddate, // for filtering
            endateRaw: item.endate,
            ponumber: item.ponumber || "-",
            grnstatuscode: item.trsts,
Supplier: `${item.suprefcode} - ${item.suppliername}`,
            grncode: item.grncode,
            debitnoteno : item.trsts !== CON_STATUS_RETURNREJECTED ? item.debitnoteno || "-" : "-",
            totaftertaxamount : item.trsts !== CON_STATUS_RETURNREJECTED
    ? fmtCurrency(item.totaftertaxamount)
    : fmtCurrency("-"),
          };
        });

        setAllData(rowsWithId); // ✅ base data
        setFilteredRows(rowsWithId); // ✅ displayed data
        console.log("Fetched:", filteredResult);

      } else {
        setAllData([]);
        setFilteredRows([]);
      }
    } catch (err) {
      console.error("Error fetching supplier list data:", err);
    }
  };

  useEffect(() => {
    if (!allData.length) {
      setFilteredRows([]);
      return;
    }

    let filtered = allData;

if (filters.search) {
  const search = filters.search.toLowerCase();

  filtered = filtered.filter((item) => {
    return Object.values({
      grncode: item.grncode,
      grnreturncode: item.grnreturncode,
      ponumber: item.ponumber,
      suppliername: item.suppliername,
      suprefcode: item.suprefcode,
      invoiceno: item.invoiceno,
      debitnoteno: item.debitnoteno,
      batchno: item.batchno,
      Supplier: item.Supplier,
    })
      .some((val) =>
        val?.toString().toLowerCase().includes(search)
      );
  });
}
    if (filters.grnId) {
      const search = filters.grnId.toLowerCase();
      filtered = filtered.filter((item) =>
        item.grncode.toString().toLowerCase().includes(search)
      );
    }
 if (filters.supplierCode) {
      const search = filters.supplierCode.toLowerCase();
      filtered = filtered.filter((item) =>
        item.supplierCode.toString().toLowerCase().includes(search)
      );
    }
    if (filters.supplierName) {
      const search = filters.supplierName.toLowerCase();
      filtered = filtered.filter((item) =>
        item.supplierName.toString().toLowerCase().includes(search)
      );
    }
    if (filters.invoiceno) {
      const search = filters.invoiceno.toLowerCase();
      filtered = filtered.filter((item) =>
        item.invoiceno.toString().toLowerCase().includes(search)
      );
    }

  if (filters.ponumber) {
      const search = filters.ponumber.toLowerCase();
      filtered = filtered.filter((item) =>
        item.ponumber.toString().toLowerCase().includes(search)
      );
    }
      if (filters.debitnoteno) {
      const search = filters.debitnoteno.toLowerCase();
      filtered = filtered.filter((item) =>
        item.debitnoteno?.toString().toLowerCase().includes(search)
      );
    }
    if (filters.batchno) {
      const search = filters.batchno.toLowerCase();
      filtered = filtered.filter((item) =>
        item.batchno?.toString().toLowerCase().includes(search)
      );
    }
    if (filters.grnreturncode) {
      const search = filters.grnreturncode.toLowerCase();
      filtered = filtered.filter((item) =>
        item.grnreturncode?.toString().toLowerCase().includes(search)
      );
    }

    if (filters.warehouse) {
      filtered = filtered.filter(
        (item) => String(item.restcode) === filters.warehouse
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (item) => String(item.trsts) === String(filters.status)
      );
    }
    if (filters.fromDate && filters.toDate) {
      const from = new Date(filters.fromDate);
      const to = new Date(filters.toDate);

      const start = from < to ? from : to;
      const end = from < to ? to : from;

      filtered = filtered.filter((item) => {
        const date = new Date(item.invoicedateRaw || item.endateRaw);
        return date >= start && date <= end;
      });
    } else if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      filtered = filtered.filter(
        (item) => new Date(item.invoicedateRaw) >= from
      );
    } else if (filters.toDate) {
      const to = new Date(filters.toDate);
      filtered = filtered.filter((item) => new Date(item.endateRaw) <= to);
    }

    setFilteredRows(filtered);
  }, [filters, allData]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const menuItems = [
    {
      text: "View",
      icon: <VisibilityOutlinedIcon />,
      onClick: (row) =>
        handleItemClick(row.grncode, row.trsts, "View", row.grnreturncode, row.returneddate,row.debitnoteno),
    },
     {
      text: "Email",
      icon: <MailIcon />,
      onClick: (row) =>
        handleItemClick(row.grncode, row.trsts, "Print", row.grnreturncode,row.debitnoteno),
       disabled: (row) => String(row.trsts) === CON_STATUS_RETURNREJECTED , // Disable if debitnoteno is not present
    },
     {
      text: "Print",
      icon: <PrintIcon />,
      onClick: (row) =>
        handleItemClick( row.grncode,
      row.trsts,
      "Print",
      row.grnreturncode,
      row.returneddate,
      row.debitnoteno),

       disabled: (row) => String(row.trsts) === CON_STATUS_RETURNREJECTED ,

    },  {
      text: "Return Note",
      icon: <DescriptionIcon />,
      onClick: (row) =>
        handleItemClick(row.grncode, row.trsts, "Return Note",   row.grnreturncode,
      row.returneddate,
      row.debitnoteno),
       disabled: (row) => String(row.trsts) === CON_STATUS_RETURNREJECTED ,
    },
     {
      text: "Debit Note",
      icon: <SummarizeIcon />,
      onClick: (row) =>
        handleItemClick(row.grncode, row.trsts, "Print",  row.grnreturncode,
      row.returneddate,
      row.debitnoteno),
       disabled: (row) => String(row.trsts) === CON_STATUS_RETURNREJECTED , // Disable if debitnoteno is not present
    },
  ];

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            GRN Management
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
         Purchases Return History
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewReturnGoodGrnData.name}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
              <Box
                sx={{
                  gap: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  alignItems: "center",
                }}
              ></Box>
            </Grid>
          </Grid>
        </AppBar>

        <FilterReturnSecrchByID
          warehouseOptions={filterOptions.warehouseOptions}
          grnStatusTypes={grnStatusTypes}
          onFilterChange={handleFilterChange}
            searchFields={SEARCH_FIELDS_RTNHISTORY}

        />

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={ViewReturnGoodGrnData.columns}
            rows={filteredRows}
            menuItems={menuItems}
            tabletitle={ViewReturnGoodGrnData.name}
            gridid="field"
            sx={styles.view_data_grid_page}
            grnStatusTypes={grnStatusTypes}
           showSkeletonWhenEmpty={false}
             showCheckbox={false}
          />
        </Box>
      </Box>
    </>
  );
}

export default GoodsReturnHistory;
